module.exports = __webpack_public_path__ + "static/media/calendar.67772324.svg";